import { Button, ButtonMode, Modal, ModalWidth } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { ArticlePermissions } from '../../../../models';
import { useGlobalModalContext } from '../../../GlobalModal';
import LoanWaiverContent from '../LoanWaiverContent/LoanWaiverContent';
import { LOAN_WAIVER_HEADER } from '../LoanWaiverContent/LoanWaiverContent.constans';
import styles from '../../LockedArticle/LockedArticleModal/LockedArticleModal.module.scss';

const cx = classNames.bind(styles);

export interface LoanWaiverModalProps {
  onConfirm: () => void;
  articlePermissions: ArticlePermissions;
}

const LoanWaiverModal = ({ articlePermissions, onConfirm }: LoanWaiverModalProps): ReactElement => {
  const { closeModal } = useGlobalModalContext();
  const { quota } = articlePermissions;

  const renderFooter = () => (
    <>
      <Button dataTestId="loan-modal-cancel-button" mode={ButtonMode.SECONDARY} onClick={closeModal}>
        Cancel
      </Button>
      <Button type="submit" onClick={onConfirm} dataTestId="loan-modal-continue-button" mode={ButtonMode.PRIMARY}>
        Confirm
      </Button>
    </>
  );

  return (
    <Modal
      dataTestId="loan-waiver-modal"
      headerTitle={LOAN_WAIVER_HEADER}
      onClose={closeModal}
      width={ModalWidth.Small}
      className={cx('body')}
      open
      footer={renderFooter()}
    >
      <LoanWaiverContent onConfirm={onConfirm} onCancel={closeModal} quota={quota} />
    </Modal>
  );
};

export default LoanWaiverModal;
